import React, { useEffect, useState } from "react";
import { LuBell, LuMessageSquare, LuMail, LuSmartphone } from "react-icons/lu";
import { getNotifPreferences, setNotifPreferences } from "../../Services/engagementService";
import { successToast } from "../../utils/toasts";

const CHANNELS = [
  { key: "push", label: "App alerts", desc: "In-app notifications", icon: <LuBell size={18} /> },
  { key: "whatsapp", label: "WhatsApp", desc: "Lead & payout updates on WhatsApp", icon: <LuMessageSquare size={18} /> },
  { key: "sms", label: "SMS", desc: "Text message alerts", icon: <LuSmartphone size={18} /> },
  { key: "email", label: "Email", desc: "Updates to your inbox", icon: <LuMail size={18} /> },
];

const Toggle = ({ on, onChange }) => (
  <button
    onClick={onChange}
    className={`w-11 h-6 rounded-full transition-colors relative ${on ? "bg-[#425F80]" : "bg-gray-300"}`}
  >
    <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all ${on ? "left-[22px]" : "left-0.5"}`} />
  </button>
);

const NotificationSettings = () => {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    getNotifPreferences()
      .then((p) => setPrefs(p || { push: true, whatsapp: true, sms: false, email: true }))
      .catch(() => setPrefs({ push: true, whatsapp: true, sms: false, email: true }));
  }, []);

  const toggle = (key) => {
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    setNotifPreferences({ [key]: next[key] })
      .then(() => successToast("Saved"))
      .catch(() => {});
  };

  if (!prefs) return <div className="page-container p-6 text-gray-400">Loading…</div>;

  return (
    <div className="page-container p-6 max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-800 mb-1">Notification Settings</h1>
      <p className="text-gray-500 mb-6">Choose how you want to hear from us.</p>
      <div className="space-y-3">
        {CHANNELS.map((c) => (
          <div key={c.key} className="flex items-center gap-4 bg-white rounded-xl border border-gray-100 px-4 py-4">
            <div className="w-10 h-10 rounded-full bg-[#425F80]/10 text-[#425F80] flex items-center justify-center">
              {c.icon}
            </div>
            <div className="flex-1">
              <p className="font-medium text-gray-800">{c.label}</p>
              <p className="text-xs text-gray-400">{c.desc}</p>
            </div>
            <Toggle on={!!prefs[c.key]} onChange={() => toggle(c.key)} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationSettings;
